// Default to localhost:8000 for development, but allow override
const DEFAULT_SERVER_URL = "http://localhost:8000"

export const API_BASE_URL = process.env.REACT_APP_SERVER_URL || DEFAULT_SERVER_URL

export const config = {
  supabaseUrl: process.env.REACT_APP_SUPABASE_URL || "",
  supabaseAnonKey: process.env.REACT_APP_SUPABASE_ANON_KEY || "",
  serverUrl: API_BASE_URL,
  // Stripe configuration
  stripePublishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "",
  // Environment URLs
  successUrl: process.env.REACT_APP_SUCCESS_URL || `${window.location.origin}/billing`,
  cancelUrl: process.env.REACT_APP_CANCEL_URL || `${window.location.origin}/billing`,
}

// Log configuration in development
if (process.env.NODE_ENV === "development") {
  console.log("[Config] Server URL:", config.serverUrl)
  console.log("[Config] Supabase URL:", config.supabaseUrl ? "Set" : "Not set")
  console.log("[Config] Stripe Key:", config.stripePublishableKey ? "Set" : "Not set")
}